
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-7242987e\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./modalDetailsEnvoiBulletin.scss")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./modalDetailsEnvoiBulletin.ts"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7242987e\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./modalDetailsEnvoiBulletin.vue.html"),
  /* scopeId */
  "data-v-7242987e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Primobox/envoiBulletins/modalDetailsEnvoiBulletin/modalDetailsEnvoiBulletin.vue.html
// module id = RqWe
// module chunks = 2